<template>
  <div>
    <h1>Carrier Service:&nbsp;&nbsp;<strong>{{ value.carrier_service.name }}</strong></h1>
    <el-form
      ref="carrierServiceSettingForm"
      v-loading="isSaving"
      :rules="rules"
      :model="value"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Rating Type"
            prop="service_rate_type"
          >
            <el-select
              v-model="value.service_rate_type"
              :loading="isLoadingServiceRateTypes"
              value-key="id"
              placeholder="Select a service rate type"
              class="w-100"
              filterable
              clearable
            >
              <el-option
                v-for="serviceRateType in serviceRateTypes"
                :key="serviceRateType.id"
                :label="serviceRateType.name || '-'"
                :value="serviceRateType"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Service Type"
            prop="carrier_type"
          >
            <el-select
              v-model="value.carrier_type"
              :loading="isLoadingCarrierTypes"
              value-key="id"
              placeholder="Select a service type"
              class="w-100"
              filterable
              clearable
            >
              <el-option
                v-for="carrierType in carrierTypes"
                :key="carrierType.id"
                :label="carrierType.name || '-'"
                :value="carrierType"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="8">
          <el-form-item
            label="Cubic"
            prop="cubic"
          >
            <el-input
              v-model="value.cubic"
              placeholder="Cubic"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Extra Quote"
            prop="extra"
          >
            <el-input
              v-model="value.extra"
              placeholder="Extra Quote"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Transit Adjustment (Business Days)"
            prop="transit_modifier"
          >
            <el-input-number
              v-model="value.transit_modifier"
              :step="1"
              :precision="0"
              step-strictly
              controls-position="right"
              class="w-100"
              aria-label="Transit adjustment in business days"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col>
          <el-form-item
            label="Service Instructions"
            prop="service_spinst"
          >
            <el-input
              v-model="value.service_spinst"
              placeholder="Service Instructions"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <h2><strong>Item</strong></h2>
      <el-row :gutter="10">
        <el-col :md="6">
          <el-form-item
            label="Item Prefix"
            prop="item_prefix"
          >
            <el-input
              v-model="value.item_prefix"
              placeholder="Item Prefix"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item
            label="Item Next ID"
            prop="item_next_id"
          >
            <el-input
              v-model="value.item_next_id"
              placeholder="Item Next ID"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item
            label="Item Min"
            prop="item_min"
          >
            <el-input
              v-model="value.item_min"
              placeholder="Item Min"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item
            label="Item Max"
            prop="item_max"
          >
            <el-input
              v-model="value.item_max"
              placeholder="Item Max"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <h2><strong>Pickup</strong></h2>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Autobook Pickups (Default is all users)"
            prop="autobook"
          >
            <el-select
              v-model="value.autobook"
              placeholder="Autobook Pickups"
              class="w-100"
            >
              <el-option
                label="Yes"
                :value="true"
              />
              <el-option
                label="No"
                :value="false"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Type"
            prop="crm_pickuptype"
          >
            <el-select
              v-model="value.crm_pickuptype"
              placeholder="Pickup Type"
              class="w-100"
            >
              <el-option
                label="PERM"
                :value="true"
              />
              <el-option
                label="ADHOC"
                :value="false"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col>
          <el-form-item
            label="Pickup Notes"
            prop="crm_pickupnotes"
          >
            <el-input
              v-model="value.crm_pickupnotes"
              placeholder="Pickup Notes"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <h2><strong>Printing</strong></h2>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Service Label QTY"
            prop="service_labelqty"
          >
            <el-input
              v-model="value.service_labelqty"
              placeholder="Service Label QTY"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Service Printer"
            prop="service_printer"
          >
            <el-input
              v-model="value.service_printer"
              placeholder="Service Printer"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <h2><strong>Notifications</strong></h2>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Enable Tracking Notifications"
            prop="service_tracking_notifications"
          >
            <el-switch
              v-model="value.service_tracking_notifications"
              active-text="Yes"
              inactive-text="No"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      serviceRateTypes: [],
      carrierTypes: [],
      isSaving: false,
      isLoadingServiceRateTypes: false,
      isLoadingCarrierTypes: false,
      rules: {
        service_rate_type: [
          { required: true, message: 'Service Rate Type is required', trigger: ['blur', 'change'] }
        ],
        carrier_type: [
          { required: true, message: 'Service Type is required', trigger: ['blur', 'change'] }
        ],
        cubic: [
          { required: true, message: 'Cubic is required', trigger: ['blur', 'change'] }
        ],
        extra: [
          { required: true, message: 'Extra Quote is required', trigger: ['blur', 'change'] }
        ],
        transit_modifier: [
          { type: 'integer', required: true, message: 'Enter a whole number of business days', trigger: ['blur', 'change'] }
        ],
        item_next_id: [
          { required: true, message: 'Item Next ID is required', trigger: ['blur', 'change'] }
        ],
        item_min: [
          { required: true, message: 'Item Min is required', trigger: ['blur', 'change'] }
        ],
        item_max: [
          { required: true, message: 'Item Max is required', trigger: ['blur', 'change'] }
        ],
        autobook: [
          { required: true, message: 'Autobook Pickups is required', trigger: ['blur', 'change'] }
        ],
        crm_pickuptype: [
          { required: true, message: ' is required', trigger: ['blur', 'change'] }
        ],
        service_labelqty: [
          { required: true, message: 'Service Label QTY is required', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created () {
    this.loadList()
  },
  methods: {
    loadList () {
      // Service Rate Types
      this.isLoadingServiceRateTypes = true
      this.$sdk.dictionary_serviceratetype.list(builder => {
      }).then(res => {
        this.serviceRateTypes = res
      })
        .finally(() => {
          this.isLoadingServiceRateTypes = false
        })

      // Carrier Type
      this.isLoadingCarrierTypes = true
      this.$sdk.dictionary_carriertype.list(builder => {
        builder.order = 'name:asc'
      }).then(res => {
        this.carrierTypes = res
      })
        .finally(() => {
          this.isLoadingCarrierTypes = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
